'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormPrimaryMessage = require('./FormPrimaryMessage');

var _FormPrimaryMessage2 = _interopRequireDefault(_FormPrimaryMessage);

require('./PrimaryErrorMessage.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Lib
var PrimaryErrorMessage = function PrimaryErrorMessage(_ref) {
    var message = _ref.message,
        show = _ref.show,
        children = _ref.children,
        _ref$icon = _ref.icon,
        icon = _ref$icon === undefined ? 'cross-small' : _ref$icon;
    return _react2.default.createElement(
        _FormPrimaryMessage2.default,
        { className: 'PrimaryErrorMessage', message: message, show: show, icon: icon },
        children
    );
};

// Styles


PrimaryErrorMessage.propTypes = {
    message: _propTypes2.default.string,
    show: _propTypes2.default.bool,
    icon: _propTypes2.default.string,
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
};

exports.default = PrimaryErrorMessage;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/messages/PrimaryErrorMessage.js
// module id = 230
// module chunks = 0